import React, {FormEvent} from 'react'

import {FormField} from '../../../layout/Form'
import {Mod} from '../../../../types'

export type RadioType = {
	label: string
	mod?: Mod<'error'>
	name: string
	options: Array<{
		amount: number | null
		path: string
		title: string
	}>
	disabled?: boolean
	required: boolean
	selectedOption?: string
	onChange?: (value: string) => void
}

export const Radio: React.FC<RadioType> = ({
	label,
	mod,
	name,
	options,
	required,
	disabled,
	selectedOption,
	onChange: onChangeHandler
}) => (
	<FormField
		label={label + (required ? ' (*)' : '')}
		mod={mod}
		name={name}
		options={options}
		required={required}
		disabled={disabled}
		type="radio"
		selectedOption={selectedOption}
		onChange={(
			event: FormEvent<HTMLSelectElement> & {target: {value: string}}
		) => {
			if (onChangeHandler) {
				onChangeHandler(event.target.value as string)
			}
		}}
	/>
)
